import { createFileRoute, redirect } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";

// Legacy /articles/:slug redirect — preserves the slug into /blog/:slug.
// 301 (not the default 307): the /articles content is permanently gone, so
// Google should retire the old URL and pass its signals to /blog/:slug.
export const Route = createFileRoute("/articles/$slug")({
  head: ({ params }) => seoHead(`/articles/${params.slug}`),
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/blog/$slug",
      params: { slug: params.slug },
      replace: true,
      statusCode: 301,
    });
  },
});